<div
  class="list-card-slider"
  #slider
  [class.list-card-slider--load-rest-of-images]="loadRestOfImages"
  [class.list-card-slider--is-panning]="isPanning"
  [class.list-card-slider--no-slider]="!canSlide"
>
  <div class="list-card-slider__slides">
    <div
      class="list-card-slider__slide"
      *ngFor="let imageUrl of images; let i = index"
      [style.backgroundImage]="'url(' + imageUrl.url + '?size=md)'"
      [style.left]="i * 100 + '%'"
      [style.transform]="transform"
      (click)="onLinkClick()"
    ></div>

    <div
      class="list-card-slider__slide list-card-slider__slide--placeholder"
      *ngIf="images.length === 0"
      (click)="onLinkClick()"
    ></div>
  </div>

  <div class="list-card-slider__dots" *ngIf="images.length > 1">
    <lib-list-card-dots
      [images]="images"
      [currentIndex]="imageIndex"
      (dotClick)="goToImage($event)"
    ></lib-list-card-dots>
  </div>

  <div class="list-card-slider__controls" *ngIf="images.length > 1">
    <div
      class="list-card-slider__control list-card-slider__control--previous"
      [class.list-card-slider__control--hidden]="imageIndex === 0"
      (click)="previousImage()"
    >
      <i
        class="list-card-slider__control-icon material-icon material-icon--outlined"
      >
        keyboard_arrow_left
      </i>
    </div>

    <div
      class="list-card-slider__control list-card-slider__control--next"
      [class.list-card-slider__control--hidden]="
        imageIndex === images.length - 1
      "
      (click)="nextImage()"
    >
      <i
        class="list-card-slider__control-icon material-icon material-icon--outlined"
      >
        keyboard_arrow_right
      </i>
    </div>
  </div>
</div>
